import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { Accordion, AccordionSummary, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import React, { useCallback,  useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import AssetsAccordionDetails from './AssetsAccordionDetails'
import { capitalizeFirstLetter, getIsMonday } from '../../../../helpers'
import { useDefaultComponentTools } from '../../../../hooks/useDefaultComponentTools'
import {
	setSelectedAsset,
	setCurrentTab,
	wsUpdateAssets
} from '../../../../store/redusers/assets/actions'
import {
	selectAllAssetsToSocket,
	selectAssetSearchString,
	selectAssetSingle,
	selectOnlyFavorite
} from '../../../../store/redusers/assets/selectors'
import { getSocket } from '../../../../store/redusers/sockets/actions'
import { selectSocketWorks } from '../../../../store/redusers/sockets/selectors'
import { setRiskData } from '../../../../store/redusers/user/actions'
import { selectRiskData } from '../../../../store/redusers/user/selectors'
import AssetsItem from '../AssetsItem/AssetsItem'


const AccordionBody = styled(Accordion)(({ theme }) => ({
	'.MuiAccordionDetails-root': {
		padding: 0
	},
	color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#131635'
}))

function AssetsAccordion({ assetsSoIdesAll, setIsScrollBar }) {
	const { dispatch, alert, theme, t } = useDefaultComponentTools(true)
	const justFirstInit = useRef(false)
	const [expanded, setExpanded] = useState('')
	const [tab, setTab] = useState('')
	const assetSingle = useSelector(selectAssetSingle)
	const socketWorks = useSelector(selectSocketWorks)
	const allAssetsToSocket = useSelector(selectAllAssetsToSocket)
	const socket = getSocket()
	const onlyFavorite = useSelector(selectOnlyFavorite)
	const searchString = useSelector(selectAssetSearchString)
	const expandedAll = searchString.length || onlyFavorite
	const riskData = useSelector(selectRiskData)


	useEffect(() => {
		if (!assetsSoIdesAll?.length && justFirstInit.current) return
		setExpanded(getIsMonday() ? 'usd' : 'currencies')
		justFirstInit.current = true
	}, [assetsSoIdesAll])

	useEffect(() => {
		if (expanded && tab !== expanded) {
			setTab(expanded)
		}
	}, [tab, expanded])

	useEffect(() => {
		if (!tab) return
		dispatch(setCurrentTab(tab))
	}, [dispatch, tab])

	const handleChange = (newTab) => (event, newExpanded) => {
		setExpanded(newExpanded ? newTab : false)
	}

	const handleClickAsset = useCallback((assetSoId, assetName, assetType, type) => {
		dispatch(setSelectedAsset({'assetSoId': assetSoId, 'assetType': assetType}, assetName, type))
	}, [dispatch])

	const initSockets = () => {
		//eslint-disable-next-line
		// console.log('init sockets')
		socket.emit('add', [allAssetsToSocket, riskData, 1])
	}
	useEffect(() => {
		if (allAssetsToSocket?.length < 1 || !riskData?.endpoint) return
		if (!socketWorks || !allAssetsToSocket?.length) return
		initSockets()
	}, [allAssetsToSocket, riskData, socketWorks])


	useEffect(() => {
		if (!socket) return
		socket.on('update', (data) => {
			if (data) {
				dispatch(wsUpdateAssets(data, alert, t))
			}
		})
		socket.on('reconnect', () => {
			//eslint-disable-next-line
			// console.log('reconnect sockets')
			initSockets()
		})
		socket.on('spread', function (data) {
			dispatch(setRiskData(data))
		})
	}, [])

	return (
		<>
			{assetSingle ? null :
				Object.keys(assetsSoIdesAll).map((tab, index) => {
					return (
						!assetsSoIdesAll[tab].length ?
							null :
							<AccordionBody sx={{background: theme.palette.background}}
								key={tab + index}
								disableGutters
								expanded={expandedAll ? true : expanded === tab}
								onChange={expandedAll ? null : handleChange(tab)}>
								<AccordionSummary
									expandIcon={
										<KeyboardArrowDownIcon sx={{color: theme.palette.text.secondary}}/>
									}
									aria-controls={index + '-header'}
									id={index + '-header'}
									value={tab}
								>
									<Typography>{t(capitalizeFirstLetter(tab, true))}</Typography>
								</AccordionSummary>
								<AssetsAccordionDetails
									onHandleClickAsset={handleClickAsset}
									setIsScrollBar={setIsScrollBar}
									assetsSoIdes={assetsSoIdesAll[tab]} assetType={tab}/>
							</AccordionBody>
					)
				})
			}
			{assetSingle && <AssetsItem
				onHandleClickAsset={handleClickAsset}
				titleTab={tab}
				assetSoId={assetSingle.assetSoId}
				active={true}
				assetType={assetSingle.assetType}
			/>
			}
		</>
	)
}

AssetsAccordion.propTypes = {
	assetsSoIdesAll: PropTypes.object,
	setIsScrollBar: PropTypes.func
}

export default AssetsAccordion
